import { Component } from "solid-js";

export interface GradientProps {
  children: string;
}

export const Gradient: Component<GradientProps> = (props) => {
  return (
    <span class="text-fill-transparent bg-linear-right-pink bg-[size:200px] bg-clip-text bg-[position:150px_0] transition-[background-position] duration-2000 ease-in-out hover:bg-[position:350px_0]">
      {props.children}
    </span>
  );
};
